import { Mail } from "lucide-react";
import { FadeIn } from "./FadeIn";

const MAILTO =
  "mailto:katie@katiefernands.com?subject=Introduction%20for%20a%20financial%20advisor&body=Hi%20Katie%2C%0A%0AI'd%20like%20to%20introduce%20you%20to%20a%20financial%20advisor%20who%20could%20use%20more%20leads.%0A%0A";

export function ReferralCTA() {
  return (
    <section className="bg-background py-20 md:py-28">
      <FadeIn className="mx-auto max-w-6xl px-6 lg:px-10">
        {/* Offset right, narrow measure — feels like a note in the margin */}
        <div className="md:ml-[33%] max-w-xl border-l border-primary/50 pl-8 md:pl-10 py-4">
          <p className="text-xs uppercase tracking-[0.28em] text-primary mb-4">A note</p>
          <h2 className="text-2xl md:text-4xl leading-[1.15] tracking-tight text-foreground">
            Know a financial advisor who needs <em className="italic text-primary">more leads?</em>
          </h2>
          <p className="mt-5 text-muted-foreground leading-relaxed">
            A quick intro goes a long way. I keep everything confidential.
          </p>
          <a
            href={MAILTO}
            className="mt-6 inline-flex items-center gap-2 text-sm tracking-wide text-foreground border-b border-foreground/40 pb-1 hover:text-primary hover:border-primary transition-colors"
          >
            <Mail className="h-4 w-4" />
            Make an introduction &nbsp;→
          </a>
        </div>
      </FadeIn>
    </section>
  );
}
